import { environment } from './config';
import { parseQueryString } from './utils/apiUtils';

const flags: Metadata = parseQueryString(window.location.search);
export const featureFlags = {
  enableTracking: flags.enableTracking && environment === 'sandbox',
  enableDebtInvoiceWarn: environment === 'staging',
  enableSoftDelete: flags.enableSoftDelete || environment === 'staging',
  enableSubscriptionTimeline: environment === 'staging',
  verticalMenuIcon: !!flags.verticalMenuIcon,
  mpForm: !!flags.mpForm,
  pagoticId: flags.pagoticId,
  isAggregator: flags.isAggregator === 'true' || flags.isAggregator === '1',
};
